import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcSearchFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.96 2.888a7.819 7.819 0 1 0 4.265 14.373l3.481 3.481a1.261 1.261 0 1 0 1.784-1.783l-3.399-3.4A7.819 7.819 0 0 0 10.96 2.889m-5.297 7.82a5.297 5.297 0 1 1 10.593 0 5.297 5.297 0 0 1-10.593 0",
    clipRule: "evenodd"
  }));
}
var IcSearchFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcSearchFill));

export { IcSearchFill as I };
